import { render, staticRenderFns } from "./PoolDescription.vue?vue&type=template&id=2756cea8&"
import script from "./PoolDescription.vue?vue&type=script&lang=js&"
export * from "./PoolDescription.vue?vue&type=script&lang=js&"
import style0 from "./PoolDescription.vue?vue&type=style&index=0&id=2756cea8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports